<template>
 <span style="white-space: pre-wrap;"  v-html="formatedContent"></span>
</template>
<script>
export default {
  props: {
                   content: {
                       type: String,
                       default: ""
                   },
                   isActive: {
                       type: Boolean,
                       default: !0
                   },
                   delay: {
                       type: Number,
                       default: 0
                   },
                   debug: {
                       type: Boolean,
                       default: !1
                   }
               },

               data: function() {
                   return {
                       formatedContent: ""
                   }
               },
               mounted: function() {
                 var t = this;

                        for (var e = this.content.replace(/(?:\r\n|\r|\n)/g, " ").replace(/<br\s*\/?>/gi, " <br/> ").replace(/  <br\/>  /gi, " <br/> ").replace(/<\/?p>/gi, "").split(" "), n = !1, r = 0, i = e.length; r < i; r += 1) {
                            var s = e[r]; - 1 !== ["<span"].indexOf(s) ? (n = !0, this.formatedContent += '<span class="c-about__fact__word u-inline-block u-valign-middle js-word is-up">' + s + " " + e[r + 1] + " </span>") : -1 !== ["<br/>"].indexOf(s) ? this.formatedContent += s : n ? n = !1 : this.formatedContent += '<span class="c-about__fact__word u-inline-block u-valign-middle js-word is-up">' + s + " </span>"
                        }


               }
}
</script>
<style  scoped>
</style>



// WEBPACK FOOTER //
// src/components/app-words/index.vue